import "./Icons.css";
import {
  FiMinus, FiPlus, FiX, FiTrash2, FiCopy, FiFilter, FiChevronUp, FiChevronRight,
  FiArrowRight, FiShoppingCart, FiGrid, FiUser, FiHeart, FiMic, FiMenu, FiEdit,
  FiArrowDown, FiChevronLeft, FiChevronDown, FiLock
} from "react-icons/fi";
import SendBoldIcon from "../../icons/SendBoldIcon";
import { LiaTruckSolid } from "react-icons/lia";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsStarFill, BsStar } from "react-icons/bs";
import { PiPlayFill } from "react-icons/pi";
import { TbCoin } from "react-icons/tb";
import { GoArrowRight } from "react-icons/go";

const ICONS = [
  { name: "minus", Icon: FiMinus },
  { name: "plus", Icon: FiPlus },
  { name: "truck", Icon: LiaTruckSolid },
  { name: "star (fill)", Icon: BsStarFill },
  { name: "star", Icon: BsStar },
  { name: "x", Icon: FiX },

  { name: "trash", Icon: FiTrash2 },
  { name: "loading", Icon: AiOutlineLoading3Quarters, spin: true },
  { name: "copy", Icon: FiCopy },
  { name: "filter", Icon: FiFilter },
  { name: "chevron up", Icon: FiChevronUp },
  { name: "chevron right", Icon: FiChevronRight },

  { name: "plus (alt)", Icon: FiPlus },
  { name: "arrow right", Icon: FiArrowRight },
  { name: "arrow (round)", Icon: GoArrowRight },
  { name: "shopping cart", Icon: FiShoppingCart },
  { name: "grid", Icon: FiGrid },
  { name: "user", Icon: FiUser },

  { name: "arrow right (alt)", Icon: FiArrowRight },
  { name: "heart", Icon: FiHeart },
  { name: "mic", Icon: FiMic },
  { name: "send (bold)", Icon: SendBoldIcon },
  { name: "menu", Icon: FiMenu },
  { name: "edit", Icon: FiEdit },

  { name: "arrow down", Icon: FiArrowDown },
  { name: "chevron left", Icon: FiChevronLeft },
  { name: "chevron down", Icon: FiChevronDown },
  { name: "arrow in circle", Icon: GoArrowRight },
  { name: "lock", Icon: FiLock },
  { name: "coin", Icon: TbCoin },
];

export default function Icons() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Icons</h2>

      <div className="ui-iconsGrid">
        {ICONS.map(({ name, Icon, spin }) => (
          <div key={name} className="ui-iconItem">
            <div className="ui-iconBox" aria-label={name} title={name}>
              <Icon className={`ui-icon ${spin ? "spin" : ""}`} />
            </div>
            <div className="ui-iconLabel">{name}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
